(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["02-video-popup"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const videoCards = document.querySelectorAll('.video-card');
  const modal = document.getElementById('videoModal');
  const iframe = document.getElementById('videoIframe');
  const closeBtn = document.querySelector('.video-modal__close');

  if (!modal || !iframe || !closeBtn) return;

  function getYouTubeVideoId(url) {
    if (!url) return false;
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[7] && match[7].length === 11) ? match[7] : false;
  }

  function getVimeoVideoId(url) {
    if (!url) return false;
    const regExp = /vimeo\.com\/(?:video\/)?(\d+)/;
    const match = url.match(regExp);
    return match ? match[1] : false;
  }

  function openModal(videoUrl) {
    if (!videoUrl) return;
    
    let embedUrl = '';
    const youtubeId = getYouTubeVideoId(videoUrl);
    const vimeoId = getVimeoVideoId(videoUrl);
    
    if (youtubeId) {
      embedUrl = `https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0&modestbranding=1`;
    } else if (vimeoId) {
      embedUrl = `https://player.vimeo.com/video/${vimeoId}?autoplay=1&title=0&byline=0&portrait=0`;
    }
    
    if (embedUrl) {
      iframe.src = embedUrl;
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeModal() {
    modal.classList.remove('active');
    iframe.src = '';
    document.body.style.overflow = '';
  }

  videoCards.forEach(card => {
    card.addEventListener('click', function() {
      const videoUrl = this.dataset.videoUrl;
      if (videoUrl) openModal(videoUrl);
    });
  });

  closeBtn.addEventListener('click', closeModal);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal();
    }
  });

  modal.addEventListener('click', function(e) {
    if (e.target === modal) {
      closeModal();
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-tabs"] && !Shopify.designMode) return;
  try {
    
/* Comportamento da seção "RB Abas (arquivo único)" — Autor: R. Brands */

(function () {
  'use strict';

  // Evita registrar os eventos duas vezes quando a seção aparece mais de uma vez na página
  if (window.__rbTabsInit) return;
  window.__rbTabsInit = true;

  /* ---------------- Abas ---------------- */
  if (!customElements.get('rb-tabs')) {
    class RbTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-rb-tab]'));
        if (!this.tabs.length) return;

        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.nav = this.querySelector('[data-rb-nav]');
        this.nav.addEventListener('click', this.onClick);
        this.nav.addEventListener('keydown', this.onKeydown);

        // Link direto: minhaloja.com/#rb-tab-<id do bloco>
        const hash = window.location.hash.replace('#rb-tab-', '');
        if (hash && this.tabs.some((t) => t.dataset.rbTab === hash)) {
          this.select(hash, { focus: false });
        }
      }

      disconnectedCallback() {
        if (!this.nav) return;
        this.nav.removeEventListener('click', this.onClick);
        this.nav.removeEventListener('keydown', this.onKeydown);
      }

      panel(id) {
        return this.querySelector('[data-rb-panel="' + id + '"]');
      }

      select(id, opts) {
        const options = Object.assign({ focus: false, scroll: true }, opts);
        this.tabs.forEach((tab) => {
          const active = tab.dataset.rbTab === id;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;

          const panel = this.panel(tab.dataset.rbTab);
          if (!panel) return;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);

          if (active) {
            if (options.focus) tab.focus();
            if (options.scroll && this.nav.scrollWidth > this.nav.clientWidth) {
              tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
            }
          }
        });

        this.dispatchEvent(new CustomEvent('rb:tab:change', { bubbles: true, detail: { id: id } }));
      }

      onClick(event) {
        const tab = event.target.closest('[data-rb-tab]');
        if (tab) this.select(tab.dataset.rbTab);
      }

      onKeydown(event) {
        const current = this.tabs.indexOf(document.activeElement);
        if (current === -1) return;
        let next = null;

        switch (event.key) {
          case 'ArrowRight': next = (current + 1) % this.tabs.length; break;
          case 'ArrowLeft':  next = (current - 1 + this.tabs.length) % this.tabs.length; break;
          case 'Home':       next = 0; break;
          case 'End':        next = this.tabs.length - 1; break;
          default: return;
        }
        event.preventDefault();
        this.select(this.tabs[next].dataset.rbTab, { focus: true });
      }
    }

    customElements.define('rb-tabs', RbTabs);
  }

  /* Editor de temas: ao selecionar um bloco (aba ou bloco dentro dela), abre a aba correspondente */
  document.addEventListener('shopify:block:select', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const root = target.closest('rb-tabs');
    if (!root || typeof root.select !== 'function') return;

    // Bloco "Aba" selecionado: o atributo do editor fica no botão da aba
    if (target.matches('[data-rb-tab]')) {
      root.select(target.dataset.rbTab, { scroll: true });
      return;
    }
    // Bloco de conteúdo selecionado: abre a aba que o contém
    const panel = target.closest('[data-rb-panel]');
    if (panel) root.select(panel.dataset.rbPanel, { scroll: true });
  });

  /* ---------------- RB Produto ---------------- */
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-rb-variant-select]');
    if (!select) return;

    const option = select.options[select.selectedIndex];
    const wrap = select.closest('.rb-tab-product');
    if (!wrap || !option) return;

    const current = wrap.querySelector('[data-rb-price-current]');
    const compare = wrap.querySelector('[data-rb-price-compare]');
    const button = wrap.querySelector('[data-rb-add]');

    if (current) current.textContent = option.dataset.price;
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }
    if (button) {
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      if (!button.dataset.label) button.dataset.label = button.textContent.trim();
      button.textContent = available ? button.dataset.label : 'Esgotado';
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-rb-product-form]');
    if (!form || !window.fetch) return;
    event.preventDefault();

    const button = form.querySelector('[data-rb-add]');
    let msg = form.querySelector('.rb-form-msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'rb-form-msg';
      msg.setAttribute('role', 'status');
      form.appendChild(msg);
    }
    msg.textContent = '';
    msg.classList.remove('rb-form-msg--error');
    if (button) button.classList.add('is-loading');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    })
      .then((res) => res.json().then((data) => ({ ok: res.ok, data: data })))
      .then((result) => {
        if (!result.ok) {
          msg.classList.add('rb-form-msg--error');
          msg.textContent = result.data.description || result.data.message || 'Não foi possível adicionar ao carrinho.';
          return;
        }
        msg.innerHTML = 'Adicionado ao carrinho. <a href="' + root + 'cart">Ver carrinho</a>';
        document.dispatchEvent(new CustomEvent('rb:cart:added', { detail: result.data }));
        // Compatibilidade com temas que escutam este evento para atualizar o contador do carrinho
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(() => {
        // Fallback: envio tradicional do formulário
        form.removeAttribute('data-rb-product-form');
        form.submit();
      })
      .finally(() => {
        if (button) button.classList.remove('is-loading');
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-video"] && !Shopify.designMode) return;
  try {
    
/**
 * rb-video.js
 * Custom element <rb-video>: vídeo do YouTube (IFrame API, domínio youtube-nocookie)
 * ou vídeo enviado à Shopify, com botões de play/pause e som personalizados.
 * Autor: R. Brands
 */
(() => {
  'use strict';

  if (!window.customElements || window.customElements.get('rb-video')) return;

  const MOBILE_MQ = window.matchMedia('(max-width: 749px)');
  const REDUCED_MQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  const IDLE_DELAY = 2500;
  const YT_WATCHDOG = 4000;

  const LABELS = {
    play: 'Reproduzir vídeo',
    pause: 'Pausar vídeo',
    unmute: 'Ativar som',
    mute: 'Desativar som',
  };

  const fmt = (sec) => {
    const total = Math.max(0, Math.floor(sec || 0));
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = String(total % 60).padStart(2, '0');
    return h ? `${h}:${String(m).padStart(2, '0')}:${s}` : `${m}:${s}`;
  };

  const listen = (mq, fn) => (mq.addEventListener ? mq.addEventListener('change', fn) : mq.addListener(fn));
  const unlisten = (mq, fn) => (mq.removeEventListener ? mq.removeEventListener('change', fn) : mq.removeListener(fn));

  /* ------------------------------------------------------------------
     API do YouTube — carregada uma única vez por página
     ------------------------------------------------------------------ */
  let ytApiPromise = null;

  function loadYouTubeAPI() {
    if (window.YT && typeof window.YT.Player === 'function') return Promise.resolve(window.YT);
    if (ytApiPromise) return ytApiPromise;

    ytApiPromise = new Promise((resolve, reject) => {
      const previous = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        if (typeof previous === 'function') {
          try { previous(); } catch (e) { /* ignora erro de outro script */ }
        }
        resolve(window.YT);
      };

      if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        tag.async = true;
        tag.onerror = () => {
          ytApiPromise = null;
          reject(new Error('[rb-video] Não foi possível carregar a API do YouTube.'));
        };
        document.head.appendChild(tag);
      }
    });

    return ytApiPromise;
  }

  /* ------------------------------------------------------------------
     Adaptador: vídeo enviado (<video>)
     ------------------------------------------------------------------ */
  class FilePlayer {
    constructor(host, src, opts, cb) {
      const v = document.createElement('video');
      v.muted = opts.muted;
      v.defaultMuted = opts.muted;
      if (opts.muted) v.setAttribute('muted', '');
      v.loop = opts.loop;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.setAttribute('disablepictureinpicture', '');
      v.setAttribute('tabindex', '-1');
      v.preload = opts.autoplay ? 'auto' : 'metadata';
      v.src = src;

      v.addEventListener('playing', cb.onPlay);
      v.addEventListener('waiting', cb.onBuffering);
      v.addEventListener('pause', () => { if (!v.ended) cb.onPause(); });
      v.addEventListener('ended', cb.onEnded);
      v.addEventListener('volumechange', () => cb.onMute(v.muted));
      v.addEventListener('error', cb.onError);
      ['loadedmetadata', 'durationchange', 'timeupdate', 'seeked'].forEach((ev) => v.addEventListener(ev, cb.onTime));

      host.appendChild(v);
      this.el = v;
      this.isYouTube = false;
    }

    play() {
      try {
        return Promise.resolve(this.el.play());
      } catch (e) {
        return Promise.reject(e);
      }
    }

    pause() { this.el.pause(); }
    mute() { this.el.muted = true; }
    unmute() { this.el.muted = false; }
    get muted() { return this.el.muted; }
    get isBuffering() { return false; }
    get currentTime() { return this.el.currentTime || 0; }
    get duration() { return Number.isFinite(this.el.duration) ? this.el.duration : 0; }
    seek(t) { this.el.currentTime = t; }

    destroy() {
      this.el.pause();
      this.el.removeAttribute('src');
      this.el.load();
      this.el.remove();
    }
  }

  /* ------------------------------------------------------------------
     Adaptador: YouTube (IFrame Player API)
     ------------------------------------------------------------------ */
  class YouTubePlayer {
    constructor(host, videoId, opts, cb) {
      this.isYouTube = true;
      this.cb = cb;
      this.loop = opts.loop;
      this._muted = opts.muted;
      this.lastState = -1;
      this.destroyed = false;
      this.isReady = false;
      this.mount = document.createElement('div');
      host.appendChild(this.mount);

      const vars = {
        autoplay: opts.autoplay ? 1 : 0,
        mute: opts.muted ? 1 : 0,
        controls: 0,
        disablekb: 1,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0,
        origin: window.location.origin,
      };
      if (opts.loop) {
        vars.loop = 1;
        vars.playlist = videoId;
      }

      this.ready = loadYouTubeAPI().then((YT) => new Promise((resolve, reject) => {
        if (this.destroyed) {
          reject(new Error('destroyed'));
          return;
        }
        this.YT = YT;
        this.player = new YT.Player(this.mount, {
          host: 'https://www.youtube-nocookie.com',
          videoId,
          playerVars: vars,
          events: {
            onReady: () => {
              const iframe = this.player.getIframe();
              iframe.setAttribute('tabindex', '-1');
              iframe.setAttribute('title', opts.title);
              this.isReady = true;
              cb.onTime();
              resolve();
            },
            onStateChange: (e) => this.handleState(e.data),
            onError: () => cb.onError(),
          },
        });
      }));

      this.ready.catch(() => { if (!this.destroyed) cb.onError(); });
    }

    handleState(state) {
      this.lastState = state;
      const S = this.YT.PlayerState;
      if (state === S.PLAYING) this.cb.onPlay();
      else if (state === S.PAUSED) this.cb.onPause();
      else if (state === S.BUFFERING) this.cb.onBuffering();
      else if (state === S.ENDED) {
        if (this.loop) {
          this.player.seekTo(0, true);
          this.player.playVideo();
        } else {
          this.cb.onEnded();
        }
      }
    }

    play() {
      return this.ready.then(() => { this.player.playVideo(); });
    }

    pause() {
      this.ready.then(() => this.player.pauseVideo()).catch(() => {});
    }

    mute() {
      this._muted = true;
      this.ready.then(() => this.player.mute()).catch(() => {});
      this.cb.onMute(true);
    }

    unmute() {
      this._muted = false;
      this.ready.then(() => {
        this.player.unMute();
        this.player.setVolume(100);
      }).catch(() => {});
      this.cb.onMute(false);
    }

    get muted() { return this._muted; }
    get isBuffering() { return this.lastState === 3; }
    get currentTime() { return this.isReady ? this.player.getCurrentTime() || 0 : 0; }
    get duration() { return this.isReady ? this.player.getDuration() || 0 : 0; }

    seek(t, final) {
      this.ready.then(() => this.player.seekTo(t, final !== false)).catch(() => {});
    }

    destroy() {
      this.destroyed = true;
      try {
        if (this.player && typeof this.player.destroy === 'function') this.player.destroy();
      } catch (e) { /* noop */ }
    }
  }

  function makeSource(type, ytId, src) {
    if (type === 'youtube' && ytId) return { type, id: ytId, key: `yt:${ytId}` };
    if (type === 'file' && src) return { type, src, key: `file:${src}` };
    return null;
  }

  /* ------------------------------------------------------------------
     <rb-video>
     ------------------------------------------------------------------ */
  class RbVideo extends HTMLElement {
    constructor() {
      super();
      this.onFrameClick = this.onFrameClick.bind(this);
      this.onPlayClick = this.onPlayClick.bind(this);
      this.onAudioClick = this.onAudioClick.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.wake = this.wake.bind(this);
      this.onBreakpoint = this.onBreakpoint.bind(this);
      this.onSeekInput = this.onSeekInput.bind(this);
      this.onSeekChange = this.onSeekChange.bind(this);
      this.onSeekKey = this.onSeekKey.bind(this);
    }

    connectedCallback() {
      const d = this.dataset;
      this.frame = this.querySelector('[data-rb-frame]');
      this.media = this.querySelector('[data-rb-media]');
      this.playBtn = this.querySelector('[data-rb-play]');
      this.audioBtn = this.querySelector('[data-rb-audio]');
      this.seek = this.querySelector('[data-rb-seek]');
      this.timeEl = this.querySelector('[data-rb-time]');
      if (!this.frame || !this.media) return;

      this.cfg = {
        startMode: d.start,
        loop: d.loop === 'true',
        clickToggle: d.clickToggle === 'true',
        pauseOffscreen: d.pauseOffscreen === 'true',
        respectReduced: d.respectReduced === 'true',
        controls: d.controls || 'always',
        title: d.title || 'Vídeo',
      };

      this.sources = {
        desktop: makeSource(d.dType, d.dYt, d.dSrc),
        mobile: makeSource(d.mType, d.mYt, d.mSrc),
      };

      this.player = null;
      this.activeKey = null;
      this.isPlaying = false;
      this.started = false;
      this.wantPlay = false;
      this.autoPaused = false;
      this.wasIdleTouch = false;
      this.muted = d.muted === 'true';

      this.frame.addEventListener('click', this.onFrameClick);
      if (this.playBtn) this.playBtn.addEventListener('click', this.onPlayClick);
      if (this.audioBtn) this.audioBtn.addEventListener('click', this.onAudioClick);
      if (this.seek) {
        this.seek.addEventListener('input', this.onSeekInput);
        this.seek.addEventListener('change', this.onSeekChange);
        this.seek.addEventListener('keydown', this.onSeekKey);
      }
      this.addEventListener('pointerdown', this.onPointerDown, { passive: true });
      this.addEventListener('pointermove', this.wake, { passive: true });
      this.addEventListener('focusin', this.wake);
      this.addEventListener('keydown', this.wake);
      listen(MOBILE_MQ, this.onBreakpoint);

      this.setupObservers();
      this.render();
    }

    disconnectedCallback() {
      this.destroyPlayer();
      clearTimeout(this.idleTimer);
      if (this.initObserver) this.initObserver.disconnect();
      if (this.visObserver) this.visObserver.disconnect();
      this.initObserver = null;
      this.visObserver = null;

      if (this.frame) this.frame.removeEventListener('click', this.onFrameClick);
      if (this.playBtn) this.playBtn.removeEventListener('click', this.onPlayClick);
      if (this.audioBtn) this.audioBtn.removeEventListener('click', this.onAudioClick);
      if (this.seek) {
        this.seek.removeEventListener('input', this.onSeekInput);
        this.seek.removeEventListener('change', this.onSeekChange);
        this.seek.removeEventListener('keydown', this.onSeekKey);
      }
      this.removeEventListener('pointerdown', this.onPointerDown);
      this.removeEventListener('pointermove', this.wake);
      this.removeEventListener('focusin', this.wake);
      this.removeEventListener('keydown', this.wake);
      unlisten(MOBILE_MQ, this.onBreakpoint);
    }

    get shouldAutoplay() {
      if (this.cfg.startMode !== 'autoplay') return false;
      return !(this.cfg.respectReduced && REDUCED_MQ.matches);
    }

    currentSource() {
      return (MOBILE_MQ.matches && this.sources.mobile) || this.sources.desktop;
    }

    /* ---------- Inicialização preguiçosa (só perto da tela) ---------- */
    setupObservers() {
      if (!('IntersectionObserver' in window)) {
        this.init();
        return;
      }

      this.initObserver = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          this.initObserver.disconnect();
          this.initObserver = null;
          this.init();
        }
      }, { rootMargin: '300px 0px' });
      this.initObserver.observe(this);

      if (this.cfg.pauseOffscreen) {
        this.visObserver = new IntersectionObserver(
          ([entry]) => this.onVisibility(entry),
          { threshold: [0, 0.1, 0.25, 0.5] }
        );
        this.visObserver.observe(this);
      }
    }

    init() {
      if (this.shouldAutoplay) {
        this.attemptPlay();
        return;
      }
      // Vídeo enviado: carrega só os metadados para a barra já mostrar a duração.
      const src = this.currentSource();
      if (this.seek && src && src.type === 'file') this.ensurePlayer(false);
    }

    ensurePlayer(autoplay) {
      if (this.player) return this.player;
      const src = this.currentSource();
      if (!src) return null;

      this.activeKey = src.key;
      const cb = {
        onPlay: () => this.handlePlay(),
        onPause: () => this.handlePause(),
        onEnded: () => this.handleEnded(),
        onBuffering: () => { if (this.wantPlay) this.setLoading(true); },
        onMute: (m) => { this.muted = m; this.render(); },
        onError: () => this.handleError(),
        onTime: () => { if (!this.isPlaying) this.updateProgress(); },
      };
      const opts = { autoplay, muted: this.muted, loop: this.cfg.loop, title: this.cfg.title };

      this.player = src.type === 'youtube'
        ? new YouTubePlayer(this.media, src.id, opts, cb)
        : new FilePlayer(this.media, src.src, opts, cb);

      return this.player;
    }

    destroyPlayer() {
      clearTimeout(this.watchdog);
      this.stopTicker();
      if (this.player) this.player.destroy();
      this.player = null;
      this.activeKey = null;
      this.scrubbing = false;
      if (this.media) this.media.replaceChildren();
      this.renderProgress(0, 0);
    }

    /* ---------- Reprodução ---------- */
    attemptPlay() {
      const player = this.ensurePlayer(true);
      if (!player) return;

      this.wantPlay = true;
      this.setLoading(true);
      this.setBlocked(false);
      clearTimeout(this.watchdog);

      player.play()
        .then(() => {
          if (player.isYouTube) this.armWatchdog(player);
        })
        .catch(() => {
          if (player !== this.player) return;
          // Navegador bloqueou com som: tenta de novo sem som.
          if (!player.muted) {
            player.mute();
            player.play()
              .then(() => { if (player.isYouTube) this.armWatchdog(player); })
              .catch(() => this.handleBlocked());
          } else {
            this.handleBlocked();
          }
        });
    }

    // O YouTube não rejeita a promessa quando o autoplay é bloqueado; verificamos depois de alguns segundos.
    armWatchdog(player) {
      clearTimeout(this.watchdog);
      this.watchdog = setTimeout(() => {
        if (player !== this.player || !this.wantPlay || this.isPlaying || player.isBuffering) return;
        if (!player.muted) {
          player.mute();
          player.play().catch(() => {});
          this.watchdog = setTimeout(() => {
            if (player === this.player && this.wantPlay && !this.isPlaying && !player.isBuffering) {
              this.handleBlocked();
            }
          }, YT_WATCHDOG);
        } else {
          this.handleBlocked();
        }
      }, YT_WATCHDOG);
    }

    userPlay() {
      this.autoPaused = false;
      this.attemptPlay();
    }

    userPause() {
      this.wantPlay = false;
      this.autoPaused = false;
      clearTimeout(this.watchdog);
      this.setLoading(false);
      if (this.player) this.player.pause();
    }

    togglePlay() {
      if (this.isPlaying || this.wantPlay) this.userPause();
      else this.userPlay();
    }

    toggleMute() {
      const next = !this.muted;
      if (this.player) {
        if (next) this.player.mute();
        else this.player.unmute();
      }
      this.muted = next;
      this.render();
      // Ativar o som antes do primeiro play já inicia o vídeo.
      if (!next && !this.started && !this.wantPlay) this.userPlay();
    }

    /* ---------- Callbacks dos players ---------- */
    handlePlay() {
      this.isPlaying = true;
      this.started = true;
      this.wantPlay = true;
      clearTimeout(this.watchdog);
      this.setLoading(false);
      this.setBlocked(false);
      this.render();
      this.startTicker();
      this.wake();
    }

    handlePause() {
      this.isPlaying = false;
      this.stopTicker();
      this.wantPlay = false;
      this.setLoading(false);
      this.render();
    }

    handleEnded() {
      this.isPlaying = false;
      this.stopTicker();
      this.started = false;
      this.wantPlay = false;
      this.setLoading(false);
      this.render();
    }

    handleBlocked() {
      this.isPlaying = false;
      this.stopTicker();
      this.wantPlay = false;
      this.setLoading(false);
      this.setBlocked(true);
      this.render();
    }

    handleError() {
      console.warn('[rb-video] Não foi possível reproduzir o vídeo. Verifique o link ou o arquivo.');
      this.handleBlocked();
    }

    /* ---------- Eventos de interface ---------- */
    onPlayClick() {
      this.togglePlay();
      this.wake();
    }

    onAudioClick() {
      this.toggleMute();
      this.wake();
    }

    onPointerDown(e) {
      this.wasIdleTouch = e.pointerType !== 'mouse' && this.classList.contains('is-idle');
      this.wake();
    }

    onFrameClick(e) {
      if (e.target.closest('[data-rb-play], [data-rb-audio]')) return;

      // No toque, o primeiro tap com controles ocultos só os mostra.
      if (this.wasIdleTouch) {
        this.wasIdleTouch = false;
        return;
      }

      if (!this.started && !this.wantPlay) {
        this.userPlay();
        return;
      }
      if (this.cfg.clickToggle) this.togglePlay();
    }

    onVisibility(entry) {
      if (!this.player) return;
      const visible = entry.isIntersecting && (
        entry.intersectionRatio >= 0.25 ||
        entry.intersectionRect.height >= window.innerHeight * 0.5
      );

      if (!visible && (this.isPlaying || this.wantPlay)) {
        this.autoPaused = true;
        this.wantPlay = false;
        clearTimeout(this.watchdog);
        this.player.pause();
      } else if (visible && this.autoPaused) {
        this.autoPaused = false;
        this.attemptPlay();
      }
    }

    onBreakpoint() {
      if (!this.player || !this.sources.mobile) return;
      const src = this.currentSource();
      if (!src || src.key === this.activeKey) return;

      const resume = this.isPlaying || this.wantPlay;
      this.destroyPlayer();
      this.isPlaying = false;
      this.started = false;
      this.wantPlay = false;
      this.setLoading(false);
      this.setBlocked(false);
      this.render();
      if (resume) this.attemptPlay();
      else if (this.seek && src.type === 'file') this.ensurePlayer(false);
    }

    /* ---------- Controles ocultos durante a reprodução ---------- */
    wake() {
      if (!this.cfg || this.cfg.controls !== 'auto') return;
      this.classList.remove('is-idle');
      clearTimeout(this.idleTimer);
      if (!this.isPlaying) return;
      this.idleTimer = setTimeout(() => {
        if (this.isPlaying && !this.scrubbing && !this.querySelector(':focus-visible')) this.classList.add('is-idle');
      }, IDLE_DELAY);
    }

    /* ---------- Barra de progresso ---------- */
    startTicker() {
      if (!this.seek || this.rafId) return;
      const tick = () => {
        this.updateProgress();
        this.rafId = window.requestAnimationFrame(tick);
      };
      this.rafId = window.requestAnimationFrame(tick);
    }

    stopTicker() {
      if (this.rafId) window.cancelAnimationFrame(this.rafId);
      this.rafId = null;
      this.updateProgress();
    }

    updateProgress() {
      if (!this.seek || this.scrubbing) return;
      const p = this.player;
      this.renderProgress(p ? p.currentTime : 0, p ? p.duration : 0);
    }

    renderProgress(current, duration) {
      if (!this.seek) return;
      const ratio = duration > 0 ? Math.min(1, Math.max(0, current / duration)) : 0;
      this.seek.value = String(Math.round(ratio * 1000));
      this.seek.style.setProperty('--rb-progress', `${(ratio * 100).toFixed(2)}%`);
      this.seek.disabled = !(duration > 0);

      const text = `${fmt(current)} / ${fmt(duration)}`;
      if (text !== this.lastTimeText) {
        this.lastTimeText = text;
        if (this.timeEl) this.timeEl.textContent = text;
        this.seek.setAttribute('aria-valuetext', `${fmt(current)} de ${fmt(duration)}`);
      }
    }

    seekTarget() {
      const p = this.player;
      if (!p || !(p.duration > 0)) return null;
      return { p, t: (Number(this.seek.value) / 1000) * p.duration };
    }

    // Enquanto arrasta: atualiza a posição sem esperar o player.
    onSeekInput() {
      const target = this.seekTarget();
      if (!target) return;
      this.scrubbing = true;
      target.p.seek(target.t, false);
      this.renderProgress(target.t, target.p.duration);
      this.wake();
    }

    // Ao soltar: posição final.
    onSeekChange() {
      const target = this.seekTarget();
      this.scrubbing = false;
      if (!target) return;
      target.p.seek(target.t, true);
      this.renderProgress(target.t, target.p.duration);
    }

    // Teclado: setas ±5s, PageUp/PageDown ±10%, Home/End.
    onSeekKey(e) {
      const p = this.player;
      if (!p || !(p.duration > 0)) return;
      const d = p.duration;
      const steps = { ArrowLeft: -5, ArrowDown: -5, ArrowRight: 5, ArrowUp: 5, PageDown: -d * 0.1, PageUp: d * 0.1 };
      let t;
      if (e.key in steps) t = p.currentTime + steps[e.key];
      else if (e.key === 'Home') t = 0;
      else if (e.key === 'End') t = Math.max(0, d - 0.5);
      else return;

      e.preventDefault();
      t = Math.min(Math.max(0, t), d);
      p.seek(t, true);
      this.renderProgress(t, d);
      this.wake();
    }

    /* ---------- Estado visual ---------- */
    setLoading(on) { this.classList.toggle('is-loading', on); }
    setBlocked(on) { this.classList.toggle('is-blocked', on); }

    render() {
      this.classList.toggle('is-playing', this.isPlaying);
      this.classList.toggle('is-started', this.started);
      this.classList.toggle('is-muted', this.muted);
      if (!this.isPlaying) this.classList.remove('is-idle');

      if (this.playBtn) {
        this.playBtn.setAttribute('aria-label', this.isPlaying ? LABELS.pause : LABELS.play);
      }
      if (this.audioBtn) {
        this.audioBtn.setAttribute('aria-label', this.muted ? LABELS.unmute : LABELS.mute);
      }
    }
  }

  window.customElements.define('rb-video', RbVideo);
})();

  } catch(e) { console.error(e); }
})();
})();
